import Loading from './Loading'
// Uncomment the below to migrate to stateful component
// import LoadingContainer from './LoadingContainer'

export { Loading }
export default Loading
// Uncomment the below to migrate to stateful component
// export { LoadingContainer }
// export default { LoadingContainer }
